/* Superluxe estimator - Apple-style UX layer (apparel). Pairs with sl-apple-estimator.css.
   1) Turnaround tiles mirror the [data-qe-rush] <select>: a tap sets select.value and fires the same change event the
      select fires, so the estimator's own JS does all pricing. The select stays in the DOM (visually hidden) as the source
      of truth; options the estimator hides/disables (e.g. next day for embroidery) are hidden here too.
   2) Quiet tick animation when the price changes. 3) Phone-only sticky price bar (white, Pass 5) that copies the card's own numbers.
   Never reads pricing data, never computes a price. */
(function () {
  function ready(fn) { var done = false; function go() { if (!done) { done = true; fn(); } } if (document.readyState === 'complete') go(); else { document.addEventListener('DOMContentLoaded', go); window.addEventListener('load', go); } }
  ready(function () { setTimeout(init, 0); });
  function init() {
    var app = document.querySelector('.sl-qe [data-qe-app]');
    if (!app) return;
    var sel = app.querySelector('[data-qe-rush]');
    if (!sel) return;
    if (!sel.options.length) { var tries = 0, t = setInterval(function () { if (sel.options.length || ++tries > 60) { clearInterval(t); if (sel.options.length) build(); } }, 150); }
    else build();
    function build() {
      if (app.querySelector('.sl-ap-rush')) return;
      var box = document.createElement('div');
      box.className = 'sl-ap-rush'; box.setAttribute('role', 'radiogroup'); box.setAttribute('aria-label', sel.getAttribute('aria-label') || 'Turnaround');
      sel.parentNode.insertBefore(box, sel);
      sel.classList.add('sl-ap-sr'); sel.setAttribute('tabindex', '-1'); sel.setAttribute('aria-hidden', 'true');
      function render() {
        box.innerHTML = '';
        [].forEach.call(sel.options, function (o, i) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'sl-ap-rush__opt'; b.setAttribute('role', 'radio'); b.dataset.i = i;
          var txt = o.textContent, m = txt.match(/^(.*?)\s*(\(.*\))\s*$/);
          var t = document.createElement('span'); t.className = 'sl-ap-rush__t';
          var n = document.createElement('span'); n.className = 'sl-ap-rush__n'; n.textContent = m ? m[1] : txt; t.appendChild(n);
          if (m) { var s = document.createElement('span'); s.className = 'sl-ap-rush__s'; s.textContent = m[2]; t.appendChild(s); }
          b.appendChild(t); box.appendChild(b);
        });
        sync();
      }
      function sync() {
        if (box.children.length !== sel.options.length) return render();
        [].forEach.call(box.children, function (b, i) {
          var o = sel.options[i], on = sel.selectedIndex === i;
          b.hidden = !!(o.hidden || o.disabled); b.disabled = !!o.disabled;
          b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
          var m = o.textContent.match(/^(.*?)\s*(\(.*\))\s*$/), s = b.querySelector('.sl-ap-rush__s'), n = b.querySelector('.sl-ap-rush__n');
          if (n && n.textContent !== (m ? m[1] : o.textContent)) return render();
          if (s && m && s.textContent !== m[2]) s.textContent = m[2];
        });
      }
      function pick(i) {
        if (sel.options[i] && !sel.options[i].disabled && sel.selectedIndex !== i) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync();
      }
      box.addEventListener('click', function (e) { var b = e.target.closest('.sl-ap-rush__opt'); if (b) pick(+b.dataset.i); });
      box.addEventListener('keydown', function (e) {
        var k = e.key; if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(k) < 0) return;
        e.preventDefault(); var dir = (k === 'ArrowDown' || k === 'ArrowRight') ? 1 : -1, i = sel.selectedIndex, n = sel.options.length;
        for (var s = 0; s < n; s++) { i = (i + dir + n) % n; if (!sel.options[i].disabled && !sel.options[i].hidden) break; }
        pick(i); var b = box.children[i]; if (b) b.focus();
      });
      var form = sel.form || app;
      ['change', 'input', 'click'].forEach(function (ev) { (form.addEventListener ? form : app).addEventListener(ev, function () { setTimeout(sync, 0); }); });
      app.addEventListener('change', function () { setTimeout(sync, 0); });
      new MutationObserver(function () { setTimeout(sync, 0); }).observe(sel, { childList: true, subtree: true, attributes: true });
      render();
    }
    // price tick + phone bar
    var sum = app.querySelector('[data-qe-sum]'), pp = app.querySelector('[data-qe-pp]'), tot = app.querySelector('[data-qe-total]');
    if (!sum || !pp) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches, last = pp.textContent;
    // Phone price bar (Pass 5, Oct 31 PREVIEW): white bar fixed to the bottom on phones/tablets (CSS hides it above 900px, where the
    // card sits beside the steps). Copies the card's own [data-qe-pp] / [data-qe-total] text, so it can never disagree; no price math.
    // Shown from Step 2 down to the card; hidden while the card is on screen, in Stickers mode, or while the cookie banner is up.
    var bar = document.createElement('div'); bar.className = 'sl-ap-bar'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Price estimate');
    bar.innerHTML = '<div class="sl-ap-bar__t"><span class="sl-ap-bar__r1"><span class="sl-ap-bar__eye">Est. per piece</span><b class="sl-ap-bar__pp"></b></span><span class="sl-ap-bar__v"></span></div><button type="button" class="sl-ap-bar__go"></button>';
    document.body.appendChild(bar);
    var root = app.closest('.sl-qe'), barV = bar.querySelector('.sl-ap-bar__v'), barPP = bar.querySelector('.sl-ap-bar__pp'), go = bar.querySelector('.sl-ap-bar__go');
    var step2 = app.querySelector('.sl-qe__step--color'), sizesBox = app.querySelector('[data-qe-sizes]'), cta = sum.querySelector('[data-qe-cta]'), warnEl = sum.querySelector('[data-qe-warn]');
    var privacy = document.querySelector('.privacy-bar');
    if (root) root.setAttribute('data-ap-bar', '');
    function topOff() { var t = 0; document.querySelectorAll('.shopify-section-group-header-group, sticky-header').forEach(function (h) { var cs = getComputedStyle(h); if (cs.position === 'sticky' || cs.position === 'fixed') { var r = h.getBoundingClientRect(); if (r.top <= 1 && r.bottom > 0 && r.height < 240) t = Math.max(t, r.bottom); } }); return t; }
    function goTo(el, focusEl) { if (!el) return; var y = el.getBoundingClientRect().top + window.pageYOffset - topOff() - 16; window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' }); if (focusEl) setTimeout(function () { try { focusEl.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 450); }
    function pieces() { var t = 0; app.querySelectorAll('[data-qe-size]').forEach(function (i) { t += Math.max(0, parseInt(i.value, 10) || 0); }); return t; }
    var noQty = true;
    go.addEventListener('click', function () {
      if (noQty) goTo(sizesBox ? sizesBox.closest('fieldset') || sizesBox : sum, sizesBox && sizesBox.querySelector('input:not([disabled])'));
      else goTo(sum, cta);
    });
    var sumVis = true, appVis = false, h = 0;
    function cookieUp() { if (!privacy) return false; var cs = getComputedStyle(privacy); return cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity > 0.05; }
    function upd() {
      var empty = sum.classList.contains('is-empty'), n = pieces(); noQty = !n;
      if (!empty) { barPP.textContent = pp.textContent.trim(); barV.textContent = tot ? tot.textContent.trim() : ''; bar.classList.remove('is-prompt'); go.textContent = 'Get quote'; }
      else {
        var w = warnEl && !warnEl.hidden ? (warnEl.innerText || warnEl.textContent).split('\n')[0].trim() : '';
        barPP.textContent = ''; barV.textContent = !n ? 'Enter sizes to see your price' : (w || 'Finish the steps to see your price');
        bar.classList.add('is-prompt'); go.textContent = !n ? 'Add sizes' : 'See estimate';
      }
      var reached = !step2 || step2.getBoundingClientRect().top < window.innerHeight - 80;
      var mode = document.querySelector('.sl-qe[data-mode="stickers"]');
      var on = !sumVis && appVis && reached && !mode && !app.hidden && !cookieUp();
      bar.classList.toggle('is-on', on);
      if (on && bar.offsetHeight !== h) { h = bar.offsetHeight; if (root) root.style.setProperty('--ap-bar-h', h + 'px'); }
    }
    new MutationObserver(function () {
      if (pp.textContent !== last) {
        last = pp.textContent;
        if (!reduce) [pp, tot].forEach(function (el) { if (!el) return; el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); });
      }
      upd();
    }).observe(sum, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sumVis = en[0].isIntersecting; upd(); }, { threshold: 0.15 }).observe(sum);
      var form = app.querySelector('[data-qe-form]');
      if (form) new IntersectionObserver(function (en) { appVis = en[0].isIntersecting; upd(); }).observe(form);
    }
    var raf = 0; window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; upd(); }); }, { passive: true });
    window.addEventListener('resize', upd);
    app.addEventListener('input', function () { setTimeout(upd, 0); });
    if (privacy) new MutationObserver(function () { setTimeout(upd, 0); }).observe(privacy, { attributes: true });
    document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('[data-qe-mode]')) setTimeout(upd, 0); });
    upd();
  }
})();
